module.exports = __webpack_public_path__ + "static/img/Testimonial.aac7681.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color/color-2/Testimonial.png
// module id = iV9z
// module chunks = 0